import attack from '../../request/request'
import {BASIC} from '../requers_variable'

export default {
  /**
   * 字符串类型校验
   * 
   * @param {any} rule 
   * @param {any} value 
   * @param {any} callback 
   */
  verify_str(rule, value, callback) {
    if (value === '') {
      callback(new Error('当前不能为空'));
    } else {
      callback();
    }
  },
  /**
   * 应急物资新增
   * 
   * @param {any} params 
   * @returns 
   */
  create(params) {
    if (!params) return
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/supply/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 应急物资编辑
   * 
   * @param {any} params 
   * @returns 
   */
  modify(params) {
    if (!params) return
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/supply/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 应急物资查询
   * 
   * @param {any} params 
   * @returns 
   */
  search(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/supply/search`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
  /**
   * 应急物资详情
   * 
   * @param {any} params 
   * @returns 
   */
  detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/supply/detail`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
  /**
   * 应急物资删除
   * 
   * @param {any} params 
   * @returns 
   */
  delete(params) {
    if (!params) return
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/supply/delete`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
    /**
   * 风险物资新增
   * 
   * @param {any} params 
   * @returns 
   */
  material_create(params) {
    if (!params) return
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/material/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
      /**
   * 风险物资查询
   * 
   * @param {any} params 
   * @returns 
   */
  material_search(params) {
    if (!params) return
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${BASIC}/material/search`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/data/emer/supply.js